import { CreateAppSessionsInput } from '@mildang/graphql-artifact';
import { addError } from '@shared/utils/apm';
import { createAuthAxios } from '@shared/utils/createAuthAxios';

const instance = createAuthAxios(`${process.env.NEXT_PUBLIC_APP_SESSION_API_URL}`);

export type AppSessionCreateMutationVariables = {
  input: CreateAppSessionsInput;
};

export const useAppSessionCreateMutation = () => {
  async function appSessionCreateMutation({ variables }: { variables: AppSessionCreateMutationVariables }) {
    try {
      if (!process.env.NEXT_PUBLIC_APP_SESSION_API_URL) {
        return;
      }
      await instance.post(`/app-session`, variables.input);
    } catch (e: any) {
      addError(new Error(`app-session`), {
        'error.type': 'AppSessionError',
        'error.message': e.message,
        'error.stack': e.stack,
        'error.name': e.name,
        'error.code': e.code,
        'error.description': e.description,
      });
    }
  }

  return appSessionCreateMutation;
};
